import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ListingAudit } from "../listing-audit";

@Component({
	selector: "app-confirm-deletion-modal",
	templateUrl: "./confirm-deletion-modal.component.html",
	styleUrl: "./confirm-deletion-modal.component.scss",
})
export class ConfirmDeletionModalComponent {
	@Input() public listingAudit: ListingAudit;
	constructor(private activeModal: NgbActiveModal) {}

	close = (): void => {
		this.activeModal.close();
	};

	deleteRecord() {
		this.activeModal.close(this.listingAudit);
	}
}
